import React, { useState, useContext } from "react";
import Logo from "./../../../Images/property_pincode_new.png";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Button,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
  Divider,
  Typography,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import { BASE_URL } from "../../Api/ApiUrls";

// ─── Nav structure ────────────────────────────────────────────────────────────
const navItems = [
  //  { label: "New Launching (Ad)",           path: "/admin-new-launching" },
    { label: "New Launching (Ad)",           path: "/admin-ad-property" },
  { label: "Users",        path: "/admin-customers" },
  { label: "Bank Auction", path: "/admin-bank-action-props" },
  { label: "Admin Props",  path: "/admin-properties" },
  { label: "User Props",   path: "/display-user-properties" },
  { label: "Bestdeals",    path: "/admin-bestdeals" },
  { label: "JV/JD",        path: "/admin-jvjd" },
  { label: "Wanted",       path: "/admin-wanted" },
  {
    label: "Services",
    dropdownKey: "services",
    subItems: [
      { label: "2D Plans",         path: "/admin-2dplans",      group: "Construction" },
      { label: "3D Plans",         path: "/admin-3dplans",      group: "Construction" },
      { label: "Elevations",       path: "/admin-elevation",    group: "Construction" },
      { label: "2D Interior",      path: "/twoD-interior",      group: "Interiors" },
      { label: "3D Interior",      path: "/threeD-interior",    group: "Interiors" },
      { label: "Explore Category", path: "/admin-material",     group: "Explore" },
      { label: "Packages",         path: "/admin-packages",     group: "Packages", requiresSubscription: true },
      { label: "Subscription",     path: "/admin-subscription", group: "Subscription" },
    ],
  },
  {
    label: "Chat & Requests",
    dropdownKey: "chatRequests",
    subItems: [
      { label: "Chat",    path: "/admin-inbox" },
      { label: "Request", path: "/admin-request" },
    ],
  },
];

const drawerNavItems = [
  { label: "New Launching (Ad)",           path: "/admin-new-launching" },
  { label: "Users",                   path: "/admin-customers" },
  { label: "Bank Auction Properties", path: "/admin-bank-action-props" },
  { label: "Admin Properties",        path: "/admin-properties" },
  { label: "User Properties",         path: "/display-user-properties" },
  { label: "Bestdeals",               path: "/admin-bestdeals" },
  { label: "JV/JD",                   path: "/admin-jvjd" }, 
  { label: "Wanted Properties",       path: "/admin-wanted" },
  { label: "── Construction ──",      path: null, isGroupHeader: true },
  { label: "2D Plans",                path: "/admin-2dplans" },
  { label: "3D Plans",                path: "/admin-3dplans" },
  { label: "Elevations",              path: "/admin-elevation" },
  { label: "── Interiors ──",         path: null, isGroupHeader: true },
  { label: "2D Interior",             path: "/twoD-interior" },
  { label: "3D Interior",             path: "/threeD-interior" },
  { label: "── More ──",              path: null, isGroupHeader: true },
  { label: "Explore Category",        path: "/admin-material" },
  { label: "Packages",                path: "/admin-packages" },
  { label: "Subscription",            path: "/admin-subscription" },
  { label: "── Communication ──",     path: null, isGroupHeader: true },
  { label: "Chat",                    path: "/admin-inbox" },
  { label: "Request",                 path: "/admin-request" },
];

// ─── Subscription Modal ───────────────────────────────────────────────────────


// ─── Shared styles ────────────────────────────────────────────────────────────
const navButtonSx = (active) => ({
  color: active ? "#f7e896" : "rgba(247,232,150,0.8)",
  fontWeight: active ? "bold" : "normal",
  textTransform: "none",
  letterSpacing: "0.5px",
  minWidth: "auto",
  px: 1.5,
  borderBottom: active ? "3px solid #f7e896" : "3px solid transparent",
  borderRadius: 0,
  "&:hover": { color: "#f7e896", background: "rgba(247,232,150,0.1)" },
});

const popoverPaperSx = {
  background: "linear-gradient(135deg, #0d0d25, #000)",
  color: "#f7e896",
  mt: 1,
  minWidth: 200,
  boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
  borderRadius: 2,
  border: "1px solid rgba(247,232,150,0.1)",
};

// ─── Component ────────────────────────────────────────────────────────────────
export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);

  // ── One anchor state per dropdown ─────────────────────────────────────────
  const [servicesAnchorEl,     setServicesAnchorEl]     = useState(null);
  const [chatRequestsAnchorEl, setChatRequestsAnchorEl] = useState(null);



  const isActive = (path) => location.pathname === path;

  const closeAllDropdowns = () => {
    setServicesAnchorEl(null);
    setChatRequestsAnchorEl(null);
  };

  // Active highlights for dropdown buttons
  const servicesItem     = navItems.find((i) => i.dropdownKey === "services");
  const chatRequestsItem = navItems.find((i) => i.dropdownKey === "chatRequests");
  const isServicesActive     = servicesItem?.subItems.some((s) => isActive(s.path));
  const isChatRequestsActive = chatRequestsItem?.subItems.some((s) => isActive(s.path));

  // Grouped layout for Services popover
  const groupOrder = ["Construction", "Interiors", "Explore", "Packages", "Subscription"];
  const groupedServices = groupOrder.reduce((acc, g) => {
    const items = servicesItem.subItems.filter((s) => s.group === g);
    if (items.length) acc.push({ group: g, items });
    return acc;
  }, []);

  const handleSubItemClick = (subItem, closeDropdown) => {
    closeDropdown();
  
      navigate(subItem.path);

  };

  const handleLogout = async () => {
    try {
      const userId =
        sessionStorage.getItem("user_id") || localStorage.getItem("user_id");
      if (userId) {
        await fetch(`${BASE_URL}/logout/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId }),
        });
      }
    } catch (_) {
      // silent
    } finally {
      logout();
      window.location.href = "/login";
    }
  };

  // ── Mobile Drawer ─────────────────────────────────────────────────────────
  const drawer = (
    <Box
      sx={{
        width: 280,
        background: "linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95))",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          background: "linear-gradient(135deg, #0d0d25, #000)",
          color: "#f7e896",
        }}
      >
        <Typography variant="h6">PROPERTY PINCODER</Typography>
        <IconButton onClick={() => setMobileOpen(false)} sx={{ color: "#f7e896" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <List>
        {drawerNavItems.map((item, idx) => {
          if (item.isGroupHeader) {
            return (
              <ListItem key={idx} dense>
                <Typography
                  variant="caption"
                  sx={{ color: "rgba(0,0,0,0.4)", fontWeight: "bold", letterSpacing: 1, px: 1, pt: 1 }}
                >
                  {item.label}
                </Typography>
              </ListItem>
            );
          }
          return (
            <ListItem key={item.label} disablePadding>
              <ListItemButton
                onClick={() => {
                  setMobileOpen(false);
                
                    navigate(item.path);
               
                }}
                selected={isActive(item.path)}
                sx={{
                  "&.Mui-selected": {
                    background: "linear-gradient(135deg, rgba(241,229,124,0.3), rgba(230,206,69,0.3))",
                    borderLeft: "4px solid #e6ce45",
                  },
                  "&:hover": {
                    background: "linear-gradient(135deg, rgba(241,229,124,0.2), rgba(230,206,69,0.2))",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: isActive(item.path) ? "bold" : "normal",
                    color: isActive(item.path) ? "#0d0d25" : "inherit",
                  }}
                />
                {item.requiresSubscription && (
                  <StarIcon sx={{ fontSize: 14, color: "#e6ce45", ml: 0.5 }} />
                )}
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Box sx={{ p: 2 }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{
            background: "linear-gradient(135deg, #f1e57c, #e6ce45)",
            color: "#000",
            fontWeight: "bold",
            "&:hover": { background: "linear-gradient(135deg, #ffe85c, #f0d53e)" },
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "linear-gradient(135deg, #0d0d25, #000)",
          color: "#f7e896",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, md: 64 } }}>
          {isMobile ? (
            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
              <IconButton onClick={() => setMobileOpen(true)} sx={{ color: "#f7e896" }}>
                <MenuIcon />
              </IconButton>
              <Link style={{ textDecoration: "none" }}>
                <img
                  src={Logo}
                  alt="logo"
                  style={{ height: 40, borderRadius: "50%", border: "2px solid #f7e896" }}
                />
              </Link>
              <Avatar
                onClick={(e) => setProfileAnchorEl(e.currentTarget)}
                sx={{ width: 36, height: 36, border: "2px solid #f7e896", cursor: "pointer" }}
                alt="Admin"
              />
            </Box>
          ) : (
            <>
              {/* Logo */}
              <Link style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                <img
                  src={Logo}
                  alt="PROPERTY PINCODER"
                  style={{ height: 50, borderRadius: "50%", border: "2px solid #f7e896", marginRight: 12 }}
                />
                <Typography variant="h7" sx={{ color: "#f7e896", fontWeight: "bold", letterSpacing: "1px" }}>
                  PROPERTY PINCODER
                </Typography>
              </Link>

              {/* Nav buttons */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "center",
                  gap: 0.5,
                  ml: 3,
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }}
              >
                {navItems.map((item) => {
                  if (item.subItems) {
                    const isServices      = item.dropdownKey === "services";
                    const anchorEl        = isServices ? servicesAnchorEl : chatRequestsAnchorEl;
                    const setAnchor       = isServices ? setServicesAnchorEl : setChatRequestsAnchorEl;
                    const active          = isServices ? isServicesActive : isChatRequestsActive;

                    return (
                      <Button
                        key={item.label}
                        disableRipple
                        disableElevation
                        onClick={(e) => {
                          closeAllDropdowns();
                          setAnchor(e.currentTarget);
                        }}
                        endIcon={anchorEl ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        sx={navButtonSx(active)}
                      >
                        {item.label}
                      </Button>
                    );
                  }
                  return (
                    <Button
                      key={item.label}
                      disableRipple
                      disableElevation
                      onClick={() => navigate(item.path)}
                      sx={navButtonSx(isActive(item.path))}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </Box>

              {/* Avatar */}
              <Avatar
                onClick={(e) => setProfileAnchorEl(e.currentTarget)}
                sx={{ width: 40, height: 40, ml: 2, border: "2px solid #f7e896", cursor: "pointer" }}
                alt="Admin"
              />
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* ── Services Popover ── */}
      <Popover
        open={Boolean(servicesAnchorEl)}
        anchorEl={servicesAnchorEl}
        onClose={() => setServicesAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { ...popoverPaperSx, minWidth: 220 } }}
      >
        {groupedServices.map(({ group, items }, gi) => (
          <Box key={group}>
            {gi > 0 && <Divider sx={{ borderColor: "rgba(247,232,150,0.1)", mx: 1 }} />}
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "rgba(247,232,150,0.45)",
                fontWeight: "bold",
                letterSpacing: 1.5,
                textTransform: "uppercase",
                px: 2,
                pt: gi === 0 ? 1.5 : 1,
                pb: 0.5,
              }}
            >
              {group}
            </Typography>
            {items.map((subItem) => (
              <MenuItem
                key={subItem.label}
                onClick={() => handleSubItemClick(subItem, () => setServicesAnchorEl(null))}
                sx={{
                  color: "#f7e896",
                  py: 0.8,
                  px: 2,
                  display: "flex",
                  alignItems: "center",
                  background: isActive(subItem.path) ? "rgba(247,232,150,0.12)" : "transparent",
                  fontWeight: isActive(subItem.path) ? "bold" : "normal",
                  fontSize: "0.875rem",
                  "&:hover": { background: "rgba(247,232,150,0.08)" },
                }}
              >
                {subItem.label}
                {subItem.requiresSubscription && (
                  <StarIcon sx={{ fontSize: 13, color: "#e6ce45", ml: "auto" }} />
                )}
              </MenuItem>
            ))}
          </Box>
        ))}
        <Box sx={{ pb: 1 }} />
      </Popover>

      {/* ── Chat & Requests Popover ── */}
      <Popover
        open={Boolean(chatRequestsAnchorEl)}
        anchorEl={chatRequestsAnchorEl}
        onClose={() => setChatRequestsAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: popoverPaperSx }}
      >
        <Box sx={{ py: 0.5 }}>
          {chatRequestsItem.subItems.map((subItem) => (
            <MenuItem
              key={subItem.label}
              onClick={() => handleSubItemClick(subItem, () => setChatRequestsAnchorEl(null))}
              sx={{
                color: "#f7e896",
                py: 1,
                px: 2.5,
                background: isActive(subItem.path) ? "rgba(247,232,150,0.12)" : "transparent",
                fontWeight: isActive(subItem.path) ? "bold" : "normal",
                fontSize: "0.9rem",
                "&:hover": { background: "rgba(247,232,150,0.08)" },
              }}
            >
              {subItem.label}
            </MenuItem>
          ))}
        </Box>
      </Popover>

      {/* ── Mobile Drawer ── */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{ "& .MuiDrawer-paper": { boxSizing: "border-box", width: 280, borderRight: "none" } }}
      >
        {drawer}
      </Drawer>

      {/* ── Profile Menu ── */}
      <Menu
        anchorEl={profileAnchorEl}
        open={Boolean(profileAnchorEl)}
        onClose={() => setProfileAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            background: "linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95))",
            minWidth: 200,
            borderRadius: 2,
          },
        }}
      >
        <MenuItem
          disableRipple
          onClick={() => {
            setProfileAnchorEl(null);
            handleLogout();
          }}
          sx={{ color: "error.main", "&:hover": { background: "rgba(241,229,124,0.2)" } }}
        >
          <LogoutIcon sx={{ mr: 1 }} /> Logout
        </MenuItem>
      </Menu>

      
    </>
  );
}